import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';


export interface UploadDataGuard {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const canDeactivateFn: CanDeactivateFn<UploadDataGuard> = (
  component: UploadDataGuard
) => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
